<c-card *transloco="let t">
    <c-card-body class="px-2">

            <c-row class="mb-2">
              <c-col class="col-lg-8 col-12">
                  <h4>{{ t('Escalation Procedure for') }} {{worker.name}}</h4>
              </c-col>
              <c-col class="col-lg-4 col-12 text-end">
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35352948598673-Understanding-Setting-up-an-Escalation-Procedure" target="_new" role="button"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Escalation Procedure Help') }}</a>
              </c-col>
            </c-row>

            <c-row *ngIf="escalation">
              <c-col class="col-12">
                <div class="alert alert-secondary" role="alert" *ngIf="!okService.isDismissed('worker_escalation_info')">
                  <button type="button" class="btn btn-outline-secondary btn-sm float-end" (click)="okService.doDismiss('worker_escalation_info')">{{ t('Close') }}</button>
                  
                    <b class="text-danger">{{ t('THIS IS NOT AN AUTOMATED PROCESS') }}</b><br/>
                    {{ t('The Escalation Procedure contains manual steps, for Monitors to assist Workers, should a Check In be missed or a Help Alert is issued.') }}<br/>
                    {{ t('For ') }}<b>{{ t('automated alerts') }}</b> {{ t('please use ') }}<a href="https://okalone.zendesk.com/hc/en-gb/articles/35353033606289-Setting-Up-Worker-Reminders" target="_new">{{ t('Worker Reminders') }}</a> {{ t('or') }} <a href="https://okalone.zendesk.com/hc/en-gb/articles/35352962127377-Alert-Loops-Sequenced-Monitor-Alerts" target="_new">{{ t('Alert Loops') }}</a>, {{ t('which are part of our')}} <a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('Comms Plan') }}</a>.<br/>

                    <b>{{ t('The procedure you are seeing is the Worker Escalation Procedure. It only applies to this worker. This procedure OVER-RIDES any group or company escalation procedures.') }}</b>

                    <b>{{ t('If you are using the Safety Monitoring Center then this Escalation Procedure will not be used. Please see the specific Escalation Plan for the Safety Monitoring Center.') }}</b>
                </div>

                <button type="button" class="btn btn-outline-primary me-1 mb-1" (click)="chooseEdit('wizard')">
                  <span *ngIf="escalation.active=='worker' && escalation.type=='wizard'">{{ t('Edit the Worker Escalation Procedure') }}</span>
                  <span *ngIf="escalation.active!='worker' || escalation.type!='wizard'">{{ t('Build Worker Escalation Procedure') }}</span>
                </button>

                <button type="button" class="btn btn-outline-primary me-1 mb-1" (click)="chooseEdit('custom')">
                  <span *ngIf="escalation.active=='worker' && escalation.type=='custom'">{{ t('Edit my Own Escalation Procedure') }}</span>
                  <span *ngIf="escalation.active!='worker' || escalation.type!='custom'">{{ t('Enter my Own Escalation Procedure') }}</span>
                </button>

                <button type="button" class="btn btn-outline-warning mb-1" (click)="deleteEscalation()" *ngIf="escalation.type!='none'">{{ t('Delete the Escalation Procedure') }}</button>

                <app-escalation-edit-custom *ngIf="editing && edit_view=='custom'" type="worker" [id]="worker.id" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-custom>

                <app-escalation-edit-wizard *ngIf="editing && edit_view=='wizard'" type="worker" [id]="worker.id" [escalation]="escalation" (completed)="onCompleted($event)"></app-escalation-edit-wizard>

                <br/><br/>


              <div class="alert alert-warning" role="alert"  *ngIf="escalation.active=='company'">
                {{ t('This worker is currently using the company escalation procedure.') }}
              </div>
              <div class="alert alert-warning" role="alert" *ngIf="escalation.active=='group'">
                {{ t('This worker is currently using a group escalation procedure.') }}
              </div>
              <div class="alert alert-warning" role="alert" *ngIf="escalation.active=='none'">
                {{ t('This worker does not have an escalation procedure.') }}
              </div>

                <div class="card" *ngIf="escalation.active=='worker' && !editing">
                  <div class="card-header">
                    {{ t('Your current Escalation Procedure') }}
                  </div>
                  <div class="card-body" [innerHtml]="escalation.html">

                  </div>
                </div>

              </c-col>
            </c-row>



</c-card-body>
</c-card>
